package ai.jessie.web.work

import androidx.compose.runtime.Composable

// UC-009 creation in the shared UC-008 slide-over; the calendar's IDs are kept for its tests.
@Composable
internal fun calendarEditor(
    work: WorkUiState,
    workActions: WorkActions,
    actions: WorkCalendarActions,
) {
    val close = if (work.draft != null) workActions.cancel else actions.back
    workEditor(
        work,
        workActions,
        close,
        title = "Stunden erfassen",
        panelId = "calendar-editor",
        formId = "calendar-work-form",
    )
}
